// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__6fpAE","cell":"ColumnAccessor_cell__2cJL0","firstCellAccent":"ColumnAccessor_firstCellAccent__1novk"};